/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { OwnNotificationListDto } from './OwnNotificationListDto';
import {
    OwnNotificationListDtoFromJSON,
    OwnNotificationListDtoFromJSONTyped,
    OwnNotificationListDtoToJSON,
} from './OwnNotificationListDto';

/**
 * 
 * @export
 * @interface OwnNotificationListDtoOffsetPaginationResult
 */
export interface OwnNotificationListDtoOffsetPaginationResult {
    /**
     * 
     * @type {Array<OwnNotificationListDto>}
     * @memberof OwnNotificationListDtoOffsetPaginationResult
     */
    data?: Array<OwnNotificationListDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OwnNotificationListDtoOffsetPaginationResult
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OwnNotificationListDtoOffsetPaginationResult
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof OwnNotificationListDtoOffsetPaginationResult
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof OwnNotificationListDtoOffsetPaginationResult
     */
    pageCount?: number;
}

/**
 * Check if a given object implements the OwnNotificationListDtoOffsetPaginationResult interface.
 */
export function instanceOfOwnNotificationListDtoOffsetPaginationResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OwnNotificationListDtoOffsetPaginationResultFromJSON(json: any): OwnNotificationListDtoOffsetPaginationResult {
    return OwnNotificationListDtoOffsetPaginationResultFromJSONTyped(json, false);
}

export function OwnNotificationListDtoOffsetPaginationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): OwnNotificationListDtoOffsetPaginationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(OwnNotificationListDtoFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
    };
}

export function OwnNotificationListDtoOffsetPaginationResultToJSON(value?: OwnNotificationListDtoOffsetPaginationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(OwnNotificationListDtoToJSON)),
        'totalCount': value.totalCount,
        'pageSize': value.pageSize,
        'page': value.page,
        'pageCount': value.pageCount,
    };
}

